<div class="container">
  <mat-card>
    <mat-card-title class="text-center mt-4">WorkPASS Evaluator Login</mat-card-title>
    <mat-card-content>
      <div [formGroup]="loginForm">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input
            matInput
            placeholder="Enter your username"
            formControlName="email"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            placeholder="Enter your password"
            formControlName="password"
          />
          <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{
            hidePassword ? "visibility_off" : "visibility"
          }}</mat-icon>
        </mat-form-field>
        <div class="d-flex flex-row-reverse">
          <button
            mat-raised-button
            color="primary"
            class="text-white"
            (click)="onLogin()"
            [disabled]="isLoading"
          >
            {{ isLoading ? "Logging in" : "Login" }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
